/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
import React, { forwardRef, Ref } from "react";
import { getSvgResourceForSize, getDefaultSize } from "../../utils";
import { Icon, LodestarIconProps } from "../../icon";
import { SvgTrash as TrashMedium } from "./medium/Trash";
import { SvgTrash as TrashSmall } from "./small/Trash";
const sizeMap = {
    medium: TrashMedium,
    small: TrashSmall,
};
const defaultSize = getDefaultSize(sizeMap);

export const TrashIcon = forwardRef(
    (
        { size = defaultSize, ...rest }: LodestarIconProps,
        ref: Ref<HTMLElement>
    ) => (
        <Icon
            ref={ref}
            svgComponent={getSvgResourceForSize(sizeMap, size)}
            size={size}
            {...rest}
        />
    )
);
TrashIcon.displayName = "TrashIcon";
